export const API_ENDPOINTS = {
    FIND_BY_SLUG: "",
    GET_VERIFY_TOKEN: "/api/v1/token",

    GET_OVERVIEW: "api/v1/dashboard/overview",

    GET_ALL_PERMISSION_CMS: "/api/v1/permission/app/u/r?name=CMS",
    GET_ALL_CAREER_INDEX: "/api/v1/job/index",

    //INBOX MODULE
    GET_INBOX: "/api/v1/inbox/contact/index",
    DELETE_INBOX: "/api/v1/inbox/contact/delete",
    GET_INBOX_DETAIL: "/api/v1/inbox/contact/detail",
    BATCH_DELETE_INBOX_CONTACT: "/api/v1/inbox/contact/batch-delete",

    //CAREER MODULE
    GET_CAREER_SUBMIT_INDEX: "/api/v1/inbox/application/index",
    GET_CAREER_SUBMIT_PREVIEW: "/api/v1/inbox/application/preview",
    GET_JOB_INBOX: "/api/v1/job/index",
    FIND_SECTION_BY_SLUG: "/api/v1/content/session-find-by-slug",
    GET_JOB_DEPARTMENT: "/api/v1/department/index",
    GET_JOB_LEVEL: "/api/v1/job-level/index",
    GET_JOB_DETAIL: "/api/v1/job/detail",
    GET_JOB_TYPE: "/api/v1/job-type/index",
    DELETE_CREATED_JOB: "/api/v1/job/delete",
    CREATE_JOB: "/api/v1/job/create",
    UPDATE_JOB: "/api/v1/job/update",
    UPDATE_SUBMITTED_JOB: "/api/v1/inbox/application",
    CAREER_APP_SHORTLISTED: "/api/v1/inbox/application/shortlisted",
    CAREER_APP_REJECT: "/api/v1/inbox/application/reject",
    CAREER_APP_HIRE: "/api/v1/inbox/application/hire",
    CAREER_APP_REVIEW: "/api/v1/inbox/application/review",
    BATCH_DELETE_CAREER_HIRE: "/api/v1/job/batch/delete",
    CAREER_SUBMITTED_DELETE: "/api/v1/inbox/application/delete",
    CAREER_SUBMITTED_BATCH_DELETE: "/api/v1/inbox/application/batch/delete",

    //WORKFLOW
    GET_CONTENT_VERSION_INDEX: "/api/v1/content/version/index",
    FIND_CONTENT_BY_SLUG: "/api/v1/content/cms-find-by-slug",
    FIND_CONTENT_BY_VERSION: "/api/v1/content/version/findby",
    API_WORKFLOW_PUBLISH: "/api/v1/content/publish",
    API_WORKFLOW_SUBMIT: "/api/v1/content/submit",
    GET_CONTENT_SECTION_BY_UUID: "/api/v1/content/version/section-findby",
    API_CONTENT_UPDATE: "/api/v1/content/update",

    //AUTH API
    GET_USER_ID: "/api/v1/me/id",
    GET_USER_INFO: "/api/v1/user/me",
    GET_CONVERT_PROFILE: "/api/v1/user/vdi",
    LOGOUT: "/api/v1/auth/logout",
    GET_USER_BY_UUID: (uuid: string) => `/api/v1/user/${uuid}/view`,
    GET_CMS_CONTENT: "/api/v1/content/cms-find-by-slug",
    UPDATE_CONTENT_BY_PATH: "/api/v1/content/update",
    DELETE_DRAFT_CONTENT: "/api/v1/content/version/delete",
    ADD_CONTENT_BY_PATH:  "/api/v1/content/add-content",

    //NOTIFICATION
    GET_ALL_NOTIFICATIONS: "/api/v1/notification/all",
    READ_NOTIFICATION: "/api/v1/notification/read",
    REAL_TIME_NOTIFICATION: "/api/v1/notification/realtime",
    
    //MEDIA
    GET_ALL_MEDIA: "/api/v1/media/index",
    UPLOAD_MEDIA: "/api/v1/media/upload",
    DELETE_MEDIA: "/api/v1/media/delete",
    EDIT_MEDIA_FILE: "/api/v1/media/edit-file",
    EDIT_MEDIA: "/api/v1/media/edit",
    UPDATE_STATUS_MEDIA: "/api/v1/media/usage",

}
